import React, { useEffect, useState } from "react";

import styles from './styles.scss';
import mainTitleStyles from "components/Title/MainTitle/styles.scss";
import tableCommonStyles from "components/Table/styles.scss";

import Header from "components/Layout/Header";

import SubTitle from "components/Title/SubTitle";
import Table from "components/Table";
import Button from "components/Button";
import { useSelector } from "react-redux";

const MidEnrollmentSignStep = (props) => {
    const { data } = useSelector(state => state.contract);
    const username = useSelector(state => state.pass.name);
    const personal = useSelector(state => state.contract.isPersonal);
    const defaultInfo = useSelector(state => state.contract.defaultInfo)

    const [btndisabled, setBtndisabled] = useState(true);

    useEffect( () => {
        window.addEventListener("beforeunload", function(e) {
            e.preventDefault();
            e.returnValue = "변경사항은 저장되지 않습니다";
        });
        if (!data) {
            props.history.push("/auth/contractNum");
        }
    }, []);
    
    const handleOnChangeCheck = (e) => {
        if (e.target.checked) {
            setBtndisabled(false);
        } else {
            setBtndisabled(true);
        }
    };
    const handleBtnOnClick = () => {
        if (!btndisabled) {
            props.history.push("/signature/sign");
        }
    };

    return (
        <>
            <Header onClick={() => props.history.push("/")}/>
            <div className={styles.contentBoardWrap}>
                <div className={styles.contentBoard}>
                    <div className={styles.innerWrap}>
                        <div className={mainTitleStyles.topInfo}>
                            <h1>
                                {personal && (
                                    <>
                                        <span name="username">{username ? username : "-"}</span> 님의<br/>
                                    </>
                                )}
                                계약정보 확인
                            </h1>
                            <div className={mainTitleStyles.desc}>
                                <p>
                                    전자서명을 진행하기 전, 계약내용을 확인해주세요.
                                </p>
                            </div>
                        </div>
                        <div className={styles.contBox}>
                            <div className={tableCommonStyles.tblWrap}>
                                <SubTitle title="계약 내용" descYn="N" isSpecial/>
                                <table className={tableCommonStyles.tbl01}>
                                    <tbody>
                                    {defaultInfo?.map((contact, i) => {
                                            return (
                                                <Table
                                                    name={contact?.title ? contact?.title : "-"}
                                                    value={contact?.value ? contact?.value : "-"}
                                                    key={i}
                                                />
                                            )
                                        })
                                    }
                                    </tbody>
                                </table>
                            </div>

                            <label htmlFor="check1">
                                <div className={styles.agreeCheck}>
                                    <input type="checkBox" id="check1" onChange={handleOnChangeCheck}></input>
                                    <span htmlFor="check1"></span>
                                    <p>본인은 상기 계약 내용에 대하여 동의합니다.</p>
                                </div>
                            </label>

                            <Button
                                style={{fontSize: "14px"}}
                                text={"전자서명 진행"}
                                disabled={btndisabled}
                                onClick={handleBtnOnClick}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}


export default MidEnrollmentSignStep;